import { useAlfiClients, useInfraClients, useK8sClients } from './use-clients'
import { useServices } from './use-services'

export default function useLongRunningApiData(enabled: bool = true): void {
  useServices(enabled)
  useInfraClients({ enabled })
  useK8sClients({ enabled })
  useAlfiClients({ enabled })
}
